import { Typography } from '@mui/material';
import ContextualInfo from 'Components/ContextualInfo';
import { PersonContext } from 'Context/CurrentPerson';
import { useColumnsUsers } from 'Hooks/useColumnsUsers';
import { useColumnsUsersLight } from 'Hooks/useColumnsUsersLight';
import useTranslate from 'Hooks/useTranslate';
import { useContext, useState } from 'react';
import LocalStorage from 'Tools/localStorage';
import { PersonOrder } from 'Apollo';
import UsersTableBase, { UsersTableBaseProps } from './UsersTableBase';

type AccountUsersTableProps = Omit<
  UsersTableBaseProps<PersonOrder>,
  | 'activeColumns'
  | 'onChangeColumns'
  | 'onResetColumns'
  | 'toolbarLeftContent'
  | 'canDeleteUsers'
  | 'canSubscribeUsers'
  | 'canInviteUsers'
  | 'scope'
> & {
  isMobileP: boolean;
};

function AccountUsersTable(props: Readonly<AccountUsersTableProps>) {
  const { isMobileP, ...rest } = props;
  const ts = useTranslate();
  const { currentPersonRoles } = useContext(PersonContext);

  const [columns, setColumns] = useState(
    LocalStorage.deserializeColumns(
      useColumnsUsers({}),
      LocalStorage.UsersColumns ?? []
    )
  );

  const [lightColumns, setLightColumns] = useState(
    LocalStorage.deserializeColumns(
      useColumnsUsersLight({}),
      LocalStorage.LightUsersColumns ?? []
    )
  );

  const activeColumns = isMobileP ? lightColumns : columns;

  const onChangeColumns = (newColumns: any) => {
    if (isMobileP) {
      setLightColumns(newColumns);
      LocalStorage.LightUsersColumns = LocalStorage.serializeColumns(newColumns);
    } else {
      setColumns(newColumns);
      LocalStorage.UsersColumns = LocalStorage.serializeColumns(newColumns);
    }
  };

  const onResetColumns = () => {
    if (isMobileP) {
      LocalStorage.LightUsersColumns = null;
    } else {
      LocalStorage.UsersColumns = null;
    }
  };

  const toolbarLeftContent = (
    <>
      <Typography variant="h5" sx={{ display: { xs: 'none', md: 'block' } }}>{ts('page.users.title')}</Typography>
      <ContextualInfo
        content={ts('page.users.help')}
        style={{ marginLeft: '8px' }}
      />
    </>
  );

  return (
    <UsersTableBase
      {...rest}
      activeColumns={activeColumns}
      onChangeColumns={onChangeColumns}
      onResetColumns={onResetColumns}
      toolbarLeftContent={toolbarLeftContent}
      canDeleteUsers={currentPersonRoles.isAccountAdmin}
      canSubscribeUsers={currentPersonRoles.isAccountAdmin}
      canInviteUsers={true}
      scope={{ kind: 'account' }}
    />
  );
}

export default AccountUsersTable;
